import { ArrowBack, CloudUpload, Description } from "@material-ui/icons";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "react-tabs/style/react-tabs.css";
import FetchEconodata from "../../api/fetchClientEconodata";
import LoadingButton from '@mui/lab/LoadingButton';
import * as XLSX from 'xlsx';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { alpha, styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';
import message from "../../helper/message";
import {
    Container,
    ModernHeader,
    HeaderLeft,
    HeaderContent,
    PageTitle,
    PageSubtitle,
    HeaderActions,
    BackButton,
    ResultsCard,
    SectionInfo,
    SectionInfoTitle,
    SectionSubtitle,
    EmptyState,
    EmptyTitle,
    EmptyText,
    getTheme,
} from "../../components/common";

function AplicacaoEconodata() {
    const history = useHistory();
    const theme = getTheme('default');
    const [isViewing, setIsViewing] = useState(null);
    const [columnExcelCount, secolumnExcelCount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [columns, setColumns] = useState([]);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {

    }, [isViewing]);

    const ODD_OPACITY = 0.2;

    const StripedDataGrid = muiStyled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.row}.even`]: {
            backgroundColor: theme.palette.grey[200],
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&.Mui-selected': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity,
                ),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY +
                        theme.palette.action.selectedOpacity +
                        theme.palette.action.hoverOpacity,
                    ),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: alpha(
                            theme.palette.primary.main,
                            ODD_OPACITY + theme.palette.action.selectedOpacity,
                        ),
                    },
                },
            },
        },
    }));

    const fecthCompanies = () => {
        try {
            message.info('Iniciando busca de informações!');
            let data = [];
            let dataResponse = [];
            let dataErroResponse = [];
            let i = 0;
            let listRequest = [];

            for (let index = 0; index < tableData.length; index++) {
                const element = tableData[index];
                data.push(element['col5']);
            }

            setIsLoading(true);

            while (i < data.length) {
                const lista100Itens = data.slice(i, i + 100);
                listRequest.push(FetchEconodata.post('companies', lista100Itens))
                i += 100;
            }

            // Executa todas as chamadas de API simultaneamente e aguarda todas as promessas serem resolvidas
            Promise.all(listRequest).then(res => {
                debugger
                // Processa as respostas
                res.forEach(response => {
                    const { data: responseData } = response;
                    const { empresas, erros } = responseData;
                    delete empresas["id"];
                    dataResponse.push(empresas);
                    dataErroResponse.push(erros);
                    // Faça o que for necessário com os dados da resposta
                });
                const { empresas } = res[0]["data"];
                let colunaEmpresa = empresas[0];
                colunaEmpresa.erro = '';
                // Definindo colunas com base nas chaves do primeiro objeto do array de dados
                // Definindo colunas com base nas chaves do primeiro objeto do array de dados
                const newColumns = Object.keys(colunaEmpresa).map(title => {
                    if (title.toLowerCase() === 'id') {
                        // Retorna null para ignorar essa coluna
                        return null;
                    } else {
                        return {
                            field: title,
                            headerName: `Eco-${title}`,
                            width: 280,
                            resizable: false
                        };
                    }
                }).filter(Boolean); // Filtra para remover elementos nulos


                // Adicionando novas colunas às colunas existentes
                const updatedColumns = [...columns, ...newColumns];

                // Atualizando as colunas
                setColumns(updatedColumns);
                // Mapeando os dados e mantendo a coluna BR_CNPJ como chave de relacionamento
                const mappedData = tableData.map(item => {
                    let newItem = { ...item };

                    [dataResponse, dataErroResponse].forEach(dataSet => {
                        dataSet.forEach(dataSetItem => {
                            const matchingEmpresa = dataSetItem.find(empresa => empresa.cnpj === newItem.col5);
                            if (matchingEmpresa) {
                                // Evita a mutação direta do objeto encontrado
                                const updatedMatchingEmpresa = { ...matchingEmpresa };

                                // Convertendo objetos em strings se necessário
                                Object.keys(updatedMatchingEmpresa).forEach(key => {
                                    const type = typeof updatedMatchingEmpresa[key];
                                    if (type === 'object' || type === 'array') {
                                        updatedMatchingEmpresa[key] = JSON.stringify(updatedMatchingEmpresa[key]);
                                    }
                                });

                                // Mesclando os dados da empresa com os dados existentes
                                Object.assign(newItem, updatedMatchingEmpresa);
                            }
                        });
                    });

                    return newItem;
                });


                // Atualizando os dados da tabela
                setTableData(mappedData);

            }).catch(err => {
                message.error(err.message);
                console.error(JSON.stringify(err));
            }).finally(() => {
                setIsLoading(false);
            });

        } catch (error) {
            setIsLoading(false);
            message.error(error.message);
            console.log(error)
        }
    }
    const handleFileChange = (event) => {
        try {
            setSelectedFile(event.target.files[0]);
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                const columnTitles = jsonData[1];
                const dataWithoutHeader = jsonData.slice(2);
                const filteredData = dataWithoutHeader.filter(row => row.some(cell => cell !== null && cell !== ''));

                const tableColumns = columnTitles.map((title, index) => ({ field: `col${index}`, headerName: title, width: 280 }));
                setIsViewing(tableColumns.length);
                setColumns(tableColumns);

                const tableData = filteredData.map((row, index) => {
                    const rowData = row.map((cell, index) => [`col${index}`, cell]);
                    return { id: index, ...Object.fromEntries(rowData.filter(entry => entry[1] !== undefined)) };
                });

                setTableData(tableData);
            };

            reader.readAsArrayBuffer(file);
        } catch (error) {
            message.error(error.message);
            console.log(error);
        }
    };
    // Função para exportar os dados da tabela para um arquivo XLSX
    const exportToExcel = () => {
        // Obter a data atual
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
        const yyyy = today.getFullYear();
        const formattedDate = `${dd}_${mm}_${yyyy}`;
        // Criar uma nova instância do Workbook do ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Tabela');

        // Adicionar cabeçalhos
        const headerRow = worksheet.addRow(columns.map(column => column.headerName));
        headerRow.font = { bold: true };

        // Adicionar dados
        tableData.forEach(row => {
            const rowData = columns.map(column => row[column.field]);
            worksheet.addRow(rowData);
        });

        // Ajustar a largura das colunas
        columns.forEach((column, index) => {
            const columnWidth = Math.max(10, Math.min(100, Math.max(...tableData.map(row => String(row[column.field]).length))));
            worksheet.getColumn(index + 1).width = columnWidth;
        });

        // Salvar o arquivo
        workbook.xlsx.writeBuffer()
            .then(buffer => {
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const fileName = `econodata_${formattedDate}.xlsx`;
                saveAs(blob, fileName);
                message.sucess('Valores exportados !');
            })
            .catch(error => {
                message.error('Erro ao exportar para Excel: ' + error.message);
                console.error('Erro ao exportar para Excel:', error);
            });
    };

    if (!tableData.length || !columns.length) {
        return (
            <Container>
                <ModernHeader>
                    <HeaderLeft>
                        <BackButton color={theme.primary} onClick={() => history.goBack()}>
                            <ArrowBack />
                        </BackButton>
                        <HeaderContent>
                            <PageTitle>
                                <Description style={{ marginRight: '12px', fontSize: '32px' }} />
                                Importação Econodata
                            </PageTitle>
                            <PageSubtitle>Importe arquivos Excel para enriquecer com dados do Econodata</PageSubtitle>
                        </HeaderContent>
                    </HeaderLeft>
                </ModernHeader>

                <ResultsCard>
                    <EmptyState>
                        <CloudUpload style={{ fontSize: '64px', color: '#cbd5e1', marginBottom: '16px' }} />
                        <EmptyTitle>Nenhum arquivo selecionado</EmptyTitle>
                        <EmptyText>Selecione um arquivo Excel para começar a importação</EmptyText>
                        <FileInputLabel htmlFor="fileInput">
                            <CloudUpload style={{ marginRight: '8px' }} />
                            Escolher Arquivo
                        </FileInputLabel>
                        <input
                            id="fileInput"
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                        {selectedFile && (
                            <SelectedFileName>
                                Arquivo selecionado: <strong>{selectedFile.name}</strong>
                            </SelectedFileName>
                        )}
                    </EmptyState>
                </ResultsCard>
            </Container>
        );
    }

    return (
        <Container>
            <ModernHeader>
                <HeaderLeft>
                    <BackButton color={theme.primary} onClick={() => history.goBack()}>
                        <ArrowBack />
                    </BackButton>
                    <HeaderContent>
                        <PageTitle>
                            <Description style={{ marginRight: '12px', fontSize: '32px' }} />
                            Importação Econodata
                        </PageTitle>
                        <PageSubtitle>Dados carregados do arquivo Excel</PageSubtitle>
                    </HeaderContent>
                </HeaderLeft>
                <HeaderActions>
                    <FileInputLabel htmlFor="fileInput" style={{ margin: 0 }}>
                        <CloudUpload style={{ marginRight: '8px', fontSize: '18px' }} />
                        Trocar Arquivo
                    </FileInputLabel>
                    <input
                        id="fileInput"
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                </HeaderActions>
            </ModernHeader>

            <ResultsCard>
                <SectionInfo>
                    <SectionInfoTitle>Dados da planilha</SectionInfoTitle>
                    <SectionSubtitle>
                        {selectedFile && `Arquivo: ${selectedFile.name}`} • {tableData.length} {tableData.length === 1 ? 'linha' : 'linhas'}
                    </SectionSubtitle>
                </SectionInfo>

                <DataGridWrapper>
                    <StripedDataGrid
                        rows={tableData}
                        columns={columns}
                        sx={{
                            border: 'none',
                            '& .MuiDataGrid-columnHeader': {
                                color: '#fff',
                                backgroundColor: 'primary.main',
                                fontWeight: 600,
                            },
                            '& .MuiDataGrid-cell': {
                                borderBottom: '1px solid #f0f0f0',
                            }
                        }}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                        pageSize={10}
                        disableSelectionOnClick={true}
                        sortingOrder={['asc', 'desc']}
                        autoWidth={true}
                        checkboxSelection={false}
                        rowHeight={42}
                        loading={isLoading}
                    />
                </DataGridWrapper>

                <ActionsWrapper>
                    <LoadingButton
                        loading={isLoading}
                        variant="contained"
                        onClick={fecthCompanies}
                        disabled={!selectedFile}
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                    >
                        Buscar Dados Econodata
                    </LoadingButton>
                    <LoadingButton
                        loading={isLoading}
                        variant="outlined"
                        onClick={exportToExcel}
                        disabled={!selectedFile}
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                    >
                        <FileDownloadIcon style={{ marginRight: '6px', fontSize: '18px' }} />
                        Exportar Excel
                    </LoadingButton>
                </ActionsWrapper>
            </ResultsCard>
        </Container>
    );
}



export default AplicacaoEconodata;

// Styled Components
const FileInputLabel = styled.label`
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 12px 24px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    margin-top: 16px;
    font-family: 'Mulish', sans-serif;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
    }

    &:active {
        transform: translateY(0);
    }
`;

const SelectedFileName = styled.p`
    margin-top: 16px;
    color: #64748b;
    font-size: 14px;
    font-family: 'Mulish', sans-serif;

    strong {
        color: #1f2933;
    }
`;

const DataGridWrapper = styled.div`
    width: 100%;
    height: 600px;

    @media (max-width: 768px) {
        height: 400px;
    }
`;

const ActionsWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 24px;
    border-top: 1px solid #eef2f7;
    margin-top: 24px;

    @media (max-width: 768px) {
        flex-direction: column;

        button {
            width: 100%;
        }
    }
`;
